// import Cookies from '../../../../node_modules/cookie/index';
import Cookies from 'js-cookie';

(function () {
    // Check if popup exist in DOM;
    const popup = document.querySelector('.popup__wrapper');
    if (popup) {
        // Check for cookie is set for this popup
        if (!Cookies.get(popup.id)) {
            popup.classList.remove('hidden');
            const expires = parseInt(popup.dataset.expiry, 10);
            document
                .querySelector('.popup__close-btn')
                .addEventListener('click', function () {
                    // Hide Popup from DOM
                    popup.classList.add('hidden');
                    // Set Cookie to prevent popup re-appearing, set with expiry date if provided
                    if (expires) {
                        Cookies.set(popup.id, 'hide', {
                            expires,
                        });
                    } else {
                        Cookies.set(popup.id, 'hide');
                    }
                });
        }
    }
})();
